import { motion } from 'motion/react';
import { useEffect, useState } from 'react';

import you from '../assets/images/you.png';
import me from '../assets/images/me.png';
import we from '../assets/images/we.png';

/**
 * A title component for the home page masthead.
 * Displays the title of the site as a sequence of words
 * with a fade-in animation.
 */
export const HomeMastheadTitle = () => {
	// Step state
	// 0: Initial state
	// 1: Show 'me'
	// 2: Show 'you'
	// 3: Fade both to 50%
	// 4: Show 'we'
	const [step, setStep] = useState(0);

	// Sequence of steps and delays
	useEffect(() => {
		// Timing of the animation
		const sequence = [
			{ step: 1, delay: 300 }, // Show 'me'
			{ step: 2, delay: 1500 }, // Show 'you'
			{ step: 3, delay: 2800 }, // Fade both
			{ step: 4, delay: 2800 }, // Show 'we'
		];

		// Run the animation
		sequence.forEach(({ step: nextStep, delay }) => {
			setTimeout(() => setStep(nextStep), delay);
		});
	}, []);

	return (
		<div id="home-masthead-title" className="w-full h-full flex items-center justify-center relative [grid-area:stack]">
			<div
				id="masthead-title-frame"
				className="container grid items-end h-full"
				//style={{ paddingTop: 'var(--header-height)', paddingBottom: '14vh' }}
			>
				<div className="flex relative flex-row gap-4 justify-center items-start px-4 w-full sm:gap-8 md:gap-12 lg:gap-24">
					<motion.div
						initial={{ opacity: 0 }}
						animate={{
							opacity: step >= 3 ? 0.1 : step >= 1 ? 1 : 0,
						}}
						transition={{ duration: 2.2, ease: [0.33, 1, 0.68, 1] }}
						className="flex-[403] min-w-0"
					>
						{/* 'Me' */}
						<img src={me} alt="Me" className="w-full" />
					</motion.div>

					<motion.div
						initial={{ opacity: 0 }}
						animate={{
							opacity: step === 2 ? 1 : step >= 3 ? 0.1 : 0,
						}}
						transition={{ duration: 2.2, ease: [0.33, 1, 0.68, 1] }}
						className="flex-[488] min-w-0"
					>
						{/* 'You' */}
						<img src={you} alt="You" className="w-full" />
					</motion.div>

					<motion.div
						initial={{ opacity: 0 }}
						animate={{
							opacity: step >= 4 ? 1 : 0,
						}}
						transition={{ duration: 1.2, ease: [0.33, 1, 0.68, 1] }}
						className="flex-[356] min-w-0"
					>
						{/* 'We' */}
						<img src={we} alt="We" className="w-full ]" />
					</motion.div>
				</div>
			</div>
		</div>
	);
};
